import Cookies from 'js-cookie';

// export const bucket = 'chushiyang-1300130963'; // 上传腾讯云桶名称
export const bucket = 'g12e-new-1252342885'; // 上传腾讯云桶名称

export const region = 'ap-beijing'; // 上传腾讯云地域名称


export const $Cookies = {
  get: (key) => {
    if (key) {
      return Cookies.get(key);
    }
  },
  set: (key, value) => {
    Cookies.set(key, value, { path: '/', domain: '.g12e.org', secure: false, raw: false });
  },
  remove: (key) => {
    Cookies.remove(key, { path: '/', domain: '.g12e.org', secure: false, raw: false });
  }
};

export const uuid = () => {
  const s = [];
  const hexDigits = '0123456789abcdef';
  for (let i = 0; i < 36; i++) {
    s[ i ] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[ 14 ] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
  s[ 19 ] = hexDigits.substr((s[ 19 ] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[ 8 ] = s[ 13 ] = s[ 18 ] = s[ 23 ] = '-';

  const uuid = s.join('');
  return uuid;
};

export const LoadingOptions = {
  fullscreen: true,
  lock: true,
  text: '正在加载，请稍后...',
  background: 'rgba(0,0,0,.7)'
};

export const extname = (filename) => {
  if (!filename || typeof filename != 'string') {
    return false;
  }
  let a = filename.split('').reverse().join('');
  let b = a.substring(0, a.search(/\./)).split('').reverse().join('');
  return b;
};

export const timeFormat = (str) => {
  let result = 0;
  if (str && typeof str === 'string' && str.indexOf(':') > 0) {
    let _arr = str.split(':');

    _arr.forEach((_v, _i) => {
      let _val = parseInt(_v);
      if (_val !== 0) {
        result += _val * Math.pow(60, _arr.length - 1 - _i);
      }
    });

  } else {
    result = str * 1;
  }
  return result;
};

export const isMobile = () => {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  return flag;
};

export const isIEBrowser = () => {
  let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
  let isEdge = userAgent.indexOf('Edge') > -1 && !isIE; //判断是否IE的Edge浏览器
  let isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1;
  let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
  if (isEdge || isIE || isIE11) {
    return true;
  }
  return false;
};

export const canUseVideo = () => {
  const video = document.createElement('video');
  if (!typeof (video.canPlayType)) {
    return true;
  }
  return false;
};
